import { SubGameType } from "types/game";

export function filterSubGame(subGame: SubGameType, search: string) {
  if (subGame.name.toLowerCase().indexOf(search.toLowerCase()) < 0) {
    return false;
  }

  return true;
}
